export default __webpack_public_path__ + "833d3bc2f33c37825000c608c2cfc24b.svg";